<script>

import NavBar from "@/layouts/NavBar.vue";

export default {
  name: "layoutIndex",
  components: {NavBar},
  methods:{

  }
}
</script>

<template>
  <div style="width: 100%;">
    <NavBar></NavBar>
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/layouts/index.vue